
import { supabase } from '@/integrations/supabase/client';

export const signInUser = async (email: string, password: string) => {
  try {
    console.log('AuthService: Attempting sign in for:', email);
    
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.error('AuthService: Sign in error:', error);
    } else {
      console.log('AuthService: Sign in successful');
    }

    return { error };
  } catch (error: any) {
    console.error('AuthService: Unexpected sign in error:', error);
    return { error };
  }
};

export const signUpUser = async (email: string, password: string, fullName: string, organizationId: string) => {
  try {
    const redirectUrl = `${window.location.origin}/`;
    
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectUrl,
        data: {
          full_name: fullName,
          organization_id: organizationId
        }
      }
    });

    if (error) {
      return { error };
    }

    if (data.user) {
      // Create user profile
      const { error: profileError } = await supabase
        .from('user_profiles')
        .insert({
          user_id: data.user.id,
          organization_id: organizationId,
          full_name: fullName,
          role: 'staff'
        });

      if (profileError) {
        console.error('AuthService: Error creating profile:', profileError);
      }
    }

    return { error };
  } catch (error: any) {
    return { error };
  }
};

export const signOutUser = async () => {
  console.log('AuthService: Signing out');
  const { error } = await supabase.auth.signOut();
  return { error };
};
